export default __webpack_public_path__ + "static/media/icon_home.65763548.svg";